<template>
    <main class="data-page recommend-page">
        <section class="page-hero compact-hero">
            <div><small>YAXUN VERIFIED ANALYSIS</small><h1>专家贴士</h1><p>亚讯专业分析 · 权威数据校验 · 真实赛果复盘</p></div>
            <div class="recommend-hero-message">
                <p><i>亚讯专业分析</i><strong>认证专家结合球队状态、阵容变化与赛事数据，独立形成清晰、可核验的观点。</strong></p>
                <p><i>权威数据档案</i><strong>发布时间、历史战绩与赛后结果持续留档，真实记录可查询、可复盘。</strong></p>
            </div>
        </section>
        <section class="data-panel recommend-list-panel">
            <div class="recommend-toolbar">
                <div class="filter-tabs">
                    <button v-for="(item,index) in tabList" :key="item" :class="tabIndex===index?'active':''" @click="changeTab(index)">{{item}}</button>
                </div>
                <div class="recommend-toolbar-note"><b>{{list.length}}</b> 场研究观点<span>近7天数据校验 · 实时更新</span></div>
                <button class="publish-btn" @click="toPublish" v-if="publish">＋ 发布推荐</button>
            </div>
            <div class="panel-loading" v-if="init"><van-skeleton row="8" title/></div>
            <recommend-mini :list="list" v-else-if="list.length"/>
            <div class="empty-state" v-else><b>暂无推荐数据</b><span>请稍后刷新或切换项目</span></div>
            <button class="load-more" v-if="!finished && list.length" @click="loadMore">加载更多推荐</button>
        </section>
    </main>
</template>

<script>
import RecommendMini from './public/recommend_mini'
export default {
    name:'recommend', components:{RecommendMini},
    data(){ return {
        list:[], init:true, loading:false, finished:false, pageIndex:1,
        tabList:['足球贴士','篮球贴士'], tabIndex:0, dataType:[1,2], publish:false
    }},
    created(){this.getList()},
    methods:{
        loadMore(){if(this.loading||this.finished)return;this.pageIndex++;this.getList()},
        changeTab(index){if(this.tabIndex===index)return;this.tabIndex=index;this.list=[];this.pageIndex=1;this.finished=false;this.init=true;this.getList()},
        getList(){
            this.loading=true
            this.$post(this.$api.recommend_list,{page:this.pageIndex,lastid:this.list.length?this.list[this.list.length-1].id:0,type:this.dataType[this.tabIndex]}).then(res=>{
                if(res.code===1){
                    const rows=res.data.recommend_list||[]
                    rows.forEach(i=>{if(i.user.portrait)i.user.portrait=this.$api.imgBaseUrl+i.user.portrait})
                    this.list=this.list.concat(rows);this.finished=Boolean(res.data.end)||!rows.length;this.publish=Boolean(res.data.publish)
                }else this.finished=true
            }).catch(()=>{this.$toast.fail('推荐读取失败');this.finished=true}).finally(()=>{this.init=false;this.loading=false})
        },
        toPublish(){this.$router.push('/match')}
    }
}
</script>

<style scoped>
.recommend-hero-message{position:relative;z-index:1;width:min(720px,61.8%);display:grid;grid-template-columns:1fr 1fr;gap:12px}
.recommend-hero-message p{margin:0;padding:15px 17px;display:grid;grid-template-columns:112px minmax(0,1fr);align-items:center;gap:13px;border:1px solid #e4e8ec;border-left:4px solid #e31b23;border-radius:4px;background:#fff;box-shadow:0 7px 18px rgba(31,44,57,.05)}
.recommend-hero-message i{display:inline-flex;align-items:center;justify-content:center;min-height:32px;color:#fff;background:#e31b23;font-size:12px;font-style:normal;font-weight:850;white-space:nowrap}
.recommend-hero-message p:last-child{border-left-color:#16283a}.recommend-hero-message p:last-child i{color:#fff;background:#16283a}
.recommend-hero-message strong{color:#293b4c;font-size:14px;font-weight:700;line-height:1.65;letter-spacing:.01em}
@media(max-width:1100px){.recommend-hero-message{width:60%;grid-template-columns:1fr}.recommend-hero-message p{padding:11px 13px;grid-template-columns:102px minmax(0,1fr);gap:10px}.recommend-hero-message strong{font-size:13px}}
@media(max-width:768px){.recommend-hero-message{width:100%;margin-top:17px;gap:9px}.recommend-hero-message p{padding:10px 12px;grid-template-columns:70px minmax(0,1fr);gap:10px}.recommend-hero-message i{min-height:27px;font-size:12px}.recommend-hero-message strong{font-size:13px;line-height:1.55}}
</style>
